import DependenciesLoader from '../../../model/loader/user-base-entities-loader'
import PDRELinkParams     from '../../../model/wrapper/pdre-link-params.js'
import User               from '../../../model/resource/User'
import CartRefresh
                          from '../../../model/event-handlers/cart-refresh-event'

export default {

  data () {
    return {
      fields:         [],
      show:           false,
      cartTotalCount: 0
    }
  },

  created () {
    this._show()
    this._open()
    this._initCartCount()

    CartRefresh.addCallback(() => {
      this._initCartCount()
    })
  },

  methods: {

    /**
     *
     * @private
     */
    _open () {
      this._initBase()
    },

    /**
     *
     * @returns {undefined}
     * @private
     */
    _show () {
      DependenciesLoader
        .getBasketMenu((basketMenu) => {this.show = basketMenu})
    },

    /**
     *
     * @private
     */
    _click (item, event) {
      event.preventDefault()
      this.$refs.holder.classList.remove('show')
      // this.$refs.menu.classList.remove('show')

      this.$router.push(PDRELinkParams.getRouteParams(item))
    },

    /**
     *
     * @private
     */
    _initBase () {
      let success = (response, data) => {

        if (!data) {
          return
        }

        this.fields = data.Fields
      }

      DependenciesLoader.getBasketMenuData(success, (error) => {
        this.handleApiError(error)
      })
    },

    _initCartCount () {
      User
        .getUserParams((userData) => {
          this.cartTotalCount = userData.CartCount
        }, (error) => {this.handleApiError(error)}, true)
    }
  }
}
